import React, {useState} from "react";
import LinearProgress from "@mui/material/LinearProgress";

import useMutation from "../../hooks/useMutation";
import useNotification from "../../hooks/notification";
import UploadFileButton from "../../components/UploadFileButton";
import {IMPORT_PROCUREMENT_SHEET_MUTATION} from "../../constants/graphql";

const ImportProcurementSheetButton = ({
  projectId,
  component,
  label,
  handleMenuClose,
  keepOpen,
  refetchAssets,
  ...buttonProps
}) => {
  const [loading, setLoading] = useState(false);
  const [importProcurementSheet] = useMutation(IMPORT_PROCUREMENT_SHEET_MUTATION);
  const { notifySuccess, notifyError } = useNotification();

  const onUpload = file => {
    if (!file) return notifyError("You haven't uploaded file");

    setLoading(true);

    return importProcurementSheet({
      variables: { projectId, file },
      onSuccess: () => {
        setLoading(false);
        notifySuccess("Import finished");
        refetchAssets();
        if (handleMenuClose) handleMenuClose();
      },
      onFailure: errors => {
        setLoading(false);
        notifyError(errors);
        if (handleMenuClose) handleMenuClose();
      },
    });
  };

  return (
    <>
      <UploadFileButton
        component={component}
        name="importProcurementSheet"
        disabled={loading}
        onUpload={onUpload}
        {...buttonProps}
      >
        {label || "Import Procurement Sheet"}
      </UploadFileButton>

      {loading && <LinearProgress sx={{ mt: 1 }} />}
    </>
  );
};

export default ImportProcurementSheetButton;
